import { createFileRoute } from '@tanstack/react-router'
import { Button, Flex, Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth'
import { FormItem } from '../components/form-item'
import { UpdateInput } from '../user/input/update-input'
import { LocaleRadio } from '../user/components/locale-radio'
import { AvatarCustomizer } from '../user/components/avatar-customizer'
import useForm from '../hooks/use-form'
import { useUpdateUser } from '../user/hooks'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/profile')({
    component: RouteComponent,
})

function RouteComponent() {
    const { t } = useTranslation()
    const { user } = useAuth()

    const mutation = useUpdateUser(user!.id)

    const formProps = useForm({
        mutation,
    })

    return (
        <>
            <PageTitle title={t('Update profile')} />

            <Flex
                vertical
                gap="large"
            >
                <Form
                    layout="vertical"
                    initialValues={{
                        ...user,
                    }}
                    {...formProps}
                >
                    <Flex
                        gap="large"
                        className="flex-col md:flex-row"
                    >
                        <div className="max-w-[340px] flex-1">
                            <FormItem<UpdateInput>
                                label={t('Name')}
                                name="name"
                                required
                            >
                                <Input placeholder="John Doe" />
                            </FormItem>
                            <FormItem<UpdateInput>
                                label={t('Email')}
                                name="email"
                                required
                            >
                                <Input placeholder="John Doe" />
                            </FormItem>

                            <FormItem<UpdateInput>
                                label={t('Language')}
                                name="locale"
                                required
                            >
                                <LocaleRadio />
                            </FormItem>

                            <Button
                                loading={mutation.isPending}
                                size="large"
                                type="primary"
                                htmlType="submit"
                            >
                                {t('Save')}
                            </Button>
                        </div>

                        <FormItem<UpdateInput> name="avatarConfig">
                            <AvatarCustomizer userId={user!.id} />
                        </FormItem>
                    </Flex>
                </Form>
            </Flex>
        </>
    )
}
